import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import tableReducer from 'redux/modules/table'
import barReducer from 'redux/modules/bar'
import transactionsReducer from 'redux/modules/transaction'
import consoReducer from 'redux/modules/conso'
import categoriesReducer from 'redux/modules/category'
import productsReducer from 'redux/modules/product'
import settingsReducer from 'redux/modules/settings'
import lockerReducer from 'redux/modules/locker'
import memberReducer from 'redux/modules/member'
import pricingReducer from 'redux/modules/pricing'
import playerReducer from 'redux/modules/player'
import currentMemberReducer from 'redux/modules/currentMember'
import historyReducer from 'redux/modules/history'
import authReducer from 'redux/modules/auth'
import userReducer from 'redux/modules/user'
import firebaseReducer from 'redux/modules/firebase'
import modalsReducer from 'redux/modules/modals'
import customerReducer from 'redux/modules/customer'
import selectedProductsReducer from 'redux/modules/selectedProducts'
import boardingReducer from 'redux/modules/boarding'

export default combineReducers({
  auth: authReducer,
  boarding: boardingReducer,
  settings: settingsReducer,
  routing: routerReducer,
  modals: modalsReducer,
  firebase: firebaseReducer,
  users: userReducer,
  bars: barReducer,
  tables: tableReducer,
  transactions: transactionsReducer,
  products: productsReducer,
  categories: categoriesReducer,
  consos: consoReducer,
  lockers: lockerReducer,
  members: memberReducer,
  currentMember: currentMemberReducer,
  pricings: pricingReducer,
  players: playerReducer,
  history: historyReducer,
  customers: customerReducer,
  selectedProducts: selectedProductsReducer
})

export const injectReducer = (store, { key, reducer }) => {
  store.asyncReducers[key] = reducer
  store.replaceReducer(store.asyncReducers)
}



// WEBPACK FOOTER //
// ./src/store/reducers.js